import { generateBridge } from '../Utility/GenerateBridge';

export type NotificationsBridgeSync = {
    subscribeToNotifications: (subscribe: boolean) => boolean;
    scheduleLocalNotification: (data: ILocalNotificationData) => void;
};

export interface ILocalNotificationData {
    title: string;
    body: string;
    displayTime: number;
    tag: number;
    receiveEvent: string;
    openEvent: string;
    deepLink?: string;
}

export const Notifications: NotificationsBridgeSync = generateBridge({
    name: 'Notifications',
    sync: {
        subscribeToNotifications: undefined,
        scheduleLocalNotification: undefined,
    },
    async: {},
    event: {},
});
